import EastIcon from "@mui/icons-material/East";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Modal,
  OutlinedInput,
  Slider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import animation from "../assets/animation.gif";
import BackwardIcon from "../assets/backward10sec.png";
import close from "../assets/close.png";
import ForwardIcon from "../assets/forward10sec.png";
import PauseIcon from "../assets/pausebutton.png";
import PlayIcon from "../assets/playbutton.png";
import previewupload from "../assets/previewupload.png";
import Search from "../assets/search.png";
import SoundIcon from "../assets/sound.png";
import upload from "../assets/upload.png";
import MuteIcon from "../assets/volumeMute.png";
import CustomButtons from "../helpercomponents/CustomButtons";
import SearchModal from "../helpercomponents/searchModal";
import appstore from "../store/appstore";
import LoginSignup from "./loginsignup";
import Navbar from "./navbar";
import Sharecontentmodal from "./sharecontentmodal";
import Subscribing from "./subscribing";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Podcast = () => {
  const { isLogin, setUserlogin, setUserData, userData, isSubscribed } =
    appstore();
  const [isMobileview, setIsMobileView] = useState(false);
  const [isShareModalOpen, setShareModalOpen] = useState(false);
  const [sharingLink, setSharingLink] = useState("");
  const [podcastTitle, setPodcastTitle] = useState("");
  const [mp3Link, setMp3Link] = useState("");
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [uploadFile, setUploadedFile] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchBoxvalue, setsearchBoxvalue] = useState("");
  const [diyMobile, setDiyMobile] = useState(false);
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [unfilteredPodcast, setUnfilteredPodcast] = useState([]);
  const [savePlayList, setAllSavePlaylist] = useState([]);
  const [allTrending, setAllTrending] = useState([]);
  const [mostPlayed, setMostPlayed] = useState([]);
  const [allYourUploades, setAllYourUploades] = useState([]);
  const [allPodcasts, setAllpodcasts] = useState([]);
  const [currentButton, setCurrentButton] = useState("Latest");
  const [allfilter, seAllfilter] = useState([
    "Latest",
    "Most Played",
    "Oldest",
    "Your Uploads",
    "Your Playlist",
  ]);
  const [currentPlaying, setCurrentPlaying] = useState(null);
  const [progress, setProgress] = useState({});
  const [muted, setMuted] = useState({});
  const [durations, setDurations] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const audioRefs = useRef({});
  const fetchYourUploads = async (userId) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/podcasts/user/${userId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.request(config);
      setAllYourUploades(response?.data);
    } catch (error) {}
  };
  const fetchYourFav = async (userId) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/podcasts/user/favorites/${userId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.request(config);
      setAllSavePlaylist(response?.data?.favorites);
    } catch (error) {}
  };

  const uploadFileConterToPodcast = async (e) => {
    const media = uploadFile[0];
    const fd = new FormData();
    fd.append("user_id", userData.id);
    fd.append("file", media);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/convert_pdf_to_podcast",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: fd,
    };
    try {
      setIsLoading(true);
      const response = await axios.request(config);
      setIsLoading(false);
      setDiyMobile(false);
      setUploadedFile([]);
      setCurrentButton("Your Uploads");
      // setState({
      //   ...state,
      //   newletter: { ...state.newletter, image: response.data.file_url },
      // });
      // console.log("response", );
    } catch (error) {
      // setUploadedFile([]);
      console.log("sdfsdf", error);
      setIsLoading(false);
      toast.error(error?.response?.data?.message ?? "Something went wrong!");
    }
  };
  const togglePlayPause = (index) => {
    const currentAudio = audioRefs.current[index];

    if (!currentAudio) return;

    if (currentPlaying === index) {
      currentAudio.pause();
      setCurrentPlaying(null);
    } else {
      // Pause all other audios before playing the new one
      Object.values(audioRefs.current).forEach((audio) => {
        if (audio) audio.pause();
      });

      currentAudio.play().catch((e) => console.error("Playback error:", e));
      setCurrentPlaying(index);
    }
  };

  // Function to seek audio forward/backward
  const seekAudio = (index, time) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      currentAudio.currentTime = Math.max(0, currentAudio.currentTime + time);
    }
  };

  // Function to toggle mute/unmute
  const toggleMute = (index) => {
    setMuted((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
    if (audioRefs.current[index]) {
      audioRefs.current[index].muted = !audioRefs.current[index].muted;
    }
  };

  // Function to update progress time
  const updateTime = (index) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      setProgress((prev) => ({
        ...prev,
        [index]: (currentAudio.currentTime / currentAudio.duration) * 100 || 0,
      }));
    }
  };

  // Function to update duration when metadata loads
  const updateDuration = (index) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      setDurations((prev) => ({
        ...prev,
        [index]: formatTime(currentAudio.duration),
      }));
    }
  };
  // Function to update audio time when slider is moved
  const handleSliderChange = (index, value) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      currentAudio.currentTime = (value / 100) * currentAudio.duration;
      setProgress((prev) => ({
        ...prev,
        [index]: value,
      }));
    }
  };
  // Format time (mm:ss)
  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  const getAllPodcasts = async (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/podcasts/user/1",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.request(config);
      if (id) {
        setAllpodcasts(response?.data?.filter((e) => e?.id == id));
        setUnfilteredPodcast(response?.data);
      } else {
        setAllpodcasts(response?.data);
        setUnfilteredPodcast(response?.data);
      }
    } catch (error) {}
  };
  const getAllPodcastMostPlayed = async (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/podcasts/most-played",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.request(config);
      setMostPlayed(response.data);
    } catch (error) {}
  };
  const handlesearch = (e) => {
    setsearchBoxvalue(e);
    const newArray = [];
    if (!e) {
      setAllpodcasts(unfilteredPodcast);
      return;
    }
    unfilteredPodcast.map((el) => {
      if (el.title.includes(e)) {
        newArray.push(el);
      }
    });
    setAllpodcasts(newArray);
  };
  const handleSaveToPlayList = async (pId) => {
    const fd = new FormData();
    // fd.append("user_id", userData.id);
    // fd.append("file", pId);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://simulyst.com/backend/podcasts/user/favorites`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { user_id: userData?.id, podcast_id: pId.id },
    };
    try {
      const response = await axios.request(config);
      setAllYourUploades(response?.data);
      toast.success("Saved to playlist !", { autoClose: 1000 });
      fetchYourFav(userData?.id);
    } catch (error) {}
    setMenuOpen(false);
  };
  React.useEffect(() => {
    if (window && window.innerWidth) {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
    const updateScreenWidth = () => {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };
    window.addEventListener("resize", updateScreenWidth);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("id");
    if (myParam) {
      getAllPodcasts(myParam);
      // setCurrentButton('Shat')
    } else {
      getAllPodcasts();
    }
    getAllPodcastMostPlayed();
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  useEffect(() => {
    let userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      fetchYourFav(JSON.parse(userDetails || "{}")?.id);
      setUserlogin(true);
      setUserData(JSON.parse(userDetails || "{}"));
      fetchYourUploads(JSON.parse(userDetails || "{}")?.id);
      seAllfilter([
        "Latest",
        "Oldest",
        "Most Played",
        "Your Uploads",
        "Your Playlist",
      ]);
    } else {
      seAllfilter(["Latest", "Oldest", "Most Played"]);
    }
  }, [isLogin]);
  return (
    <>
      <Navbar />
      <Box style={{ background: "#fafafa", width: "100%" }}>
        {" "}
        <SearchModal
          title={"Search for Podcast"}
          setOpen={setOpen}
          open={open}
          handlesearch={handlesearch}
          searchBoxvalue={searchBoxvalue}
        />
        <Box
          display={isMobileview ? "none" : "flex"}
          marginTop={"10px"}
          marginBottom={"35px"}
          gap={"60%"}
          alignItems={"center"}
          justifyContent={"space-around"}
        >
          <Box>
            <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
              <OutlinedInput
                type={"text"}
                placeholder="Search"
                style={{
                  width: "351px",
                  borderRadius: "35px",
                  background: "#EDEDED",
                  border: "none",
                }}
                focused={false}
                onChange={(e) => {
                  handlesearch(e.target.value);
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={"display the password"}
                      style={{ background: "#C789E4", color: "white" }}
                      edge="end"
                    >
                      <EastIcon style={{ padding: "5px" }} />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Box>
          <CustomButtons
            variant={"outlined"}
            title={"Try DIY"}
            handleFunc={() => {
              if (isLogin) {
                setDiyMobile(true);
              } else {
                setIsLoginModalOpen(true);
              }
            }}
            isDisabled={false}
            isMobileview={isMobileview}
          />
        </Box>
        <Box
          display={isMobileview ? "flex" : "none"}
          // border={"1px solid red"}
          height={"53px"}
          fontSize={"22px"}
          paddingLeft={"5%"}
          paddingRight={"5%"}
          marginTop={"3%"}
          alignItems={"center"}
          // boxShadow={1}
          fontWeight={500}
          justifyContent={"space-between"}
          position={"relative"}
        >
          <Box
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "50%",
              height: "1.5px",
              background: "linear-gradient(167deg, #ffffff, #eec9ff)",
            }}
          ></Box>
          <Box
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              width: "50%",
              height: "1.5px",
              background: "linear-gradient(244deg, #ffffff, #eec9ff)",
            }}
          ></Box>
          Podcast{" "}
          <Box display={"flex"} gap={"19px"} alignItems={"center"}>
            <img
              src={Search}
              style={{ cursor: "pointer" }}
              width={"24px"}
              height={"24px"}
              onClick={() => {
                setOpen(true);
              }}
            />
            <CustomButtons
              variant={"outlined"}
              title={"Try DIY"}
              handleFunc={() => {
                if (isLogin) {
                  setDiyMobile(true);
                } else {
                  setIsLoginModalOpen(true);
                }
              }}
              isDisabled={false}
              isMobileview={isMobileview}
            />
          </Box>
        </Box>
        <Box
          // value={allfilter}
          color="info"
          // onChange={(asd, newFormats) => {
          //   seAllfilter(newFormats);
          // }}
          style={{
            overflowX: "scroll",
            // overflow: "auto",
            marginLeft: "4%",

            whiteSpace: "nowrap",
            width: "91%",
            padding: "10px",
          }}
          aria-label="Delivery Schedule"
          className="items"
          // style={{ display: "inline-flex" }}
        >
          {allfilter.map((el) => {
            return (
              <Button
                className="item"
                style={{
                  textTransform: "none",
                  marginRight: "2%",
                  height: "35px",
                }}
                sx={{
                  background: currentButton == el ? "#F5EAFA" : "",
                  color: currentButton == el ? "#C789E4" : "grey",
                }}
                onClick={() => {
                  setCurrentButton(el);
                }}
                disableElevation
              >
                {el}
              </Button>
            );
          })}
        </Box>{" "}
        {isSubscribed ? (
          <Box >
            {currentButton == "Latest" &&
              allPodcasts
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Oldest" &&
              allPodcasts
                ?.sort(
                  (e, b) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Your Uploads" &&
              allYourUploades
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Your Playlist" &&
              savePlayList
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Most Played" &&
              mostPlayed
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
          </Box>
        ) : (
          <Box>
            {currentButton == "Latest" &&
              allPodcasts
                .slice(0, 3)
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Oldest" &&
              allPodcasts
                .slice(0, 3)
                ?.sort(
                  (e, b) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Your Uploads" &&
              allYourUploades
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Your Playlist" &&
              savePlayList
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
            {currentButton == "Most Played" &&
              mostPlayed
                .slice(0, 3)
                ?.sort(
                  (b, e) => new Date(e.created_at) - new Date(b.created_at)
                )
                ?.map((el, index) =>
                  el?.status != "completed" ? (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={animation}
                            style={{
                              width: "45%",
                              height: "90px",
                              opacity: "0.5",
                            }}
                          />
                          <Box
                            fontSize={"14px"}
                            marginTop={"20px"}
                            textAlign={"center"}
                          >
                            It will take 2-4 minutes.
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      key={index}
                      sx={{
                        width: isMobileview ? "90%" : "50%",
                        margin: "auto",
                      }}
                    >
                      <Box
                        sx={{
                          margin: "auto",
                          padding: isMobileview ? "9px" : "19px",
                          background: "white",
                          borderRadius: "12px",
                          marginTop: isMobileview ? "14px" : "35px",
                        }}
                        boxShadow={"rgba(0, 0, 0, 0.09) 0px 3px 12px"}
                      >
                        {/* Podcast Title */}
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            height={"20%"}
                            fontSize={"18px"}
                            fontWeight={500}
                            minHeight={isMobileview ? "18px" : "16px"}
                            sx={{
                              fontWeight: 400,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                                {el.title?.replace("Title: ","")?.replace(`"`,"") ??
                              "Lorem ipsum dolor sit amet consectetur."}
                          </Box>
                          <Box style={{ position: "relative" }}>
                            <MoreVertIcon
                              style={{ color: "#C789E4", cursor: "pointer" }}
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => {
                                setMenuOpen(true);

                                setAnchorEl(event.currentTarget);
                              }}
                            />
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              // style={{ position: "ab/solute" }}
                              boxShadow={0}
                              open={menuOpen}
                              onClose={() => {
                                setMenuOpen(false);
                              }}
                              // MenuListProps={{
                              //   "aria-labelledby": "basic-button",
                              // }}
                            >
                              {userData?.id ? (
                                <MenuItem
                                  boxShadow={0}
                                  onClick={() => {
                                    handleSaveToPlayList(el);
                                  }}
                                >
                                  Save to Playlist
                                </MenuItem>
                              ) : (
                                ""
                              )}
                              <MenuItem
                                boxShadow={0}
                                onClick={() => {
                                  setSharingLink(
                                    `https://simulyst.com/podcast?id=${el?.id}`
                                  );
                                  setMp3Link(el.audio_url);
                                  setPodcastTitle(el?.title);
                                  setShareModalOpen(true);
                                  setMenuOpen(false);
                                }}
                              >
                                Share
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        {/* Podcast Description */}
                        <Box
                          sx={{
                            fontSize: "14px",
                            marginTop: "8px",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#8C837D",
                          }}
                        >
                          {el.description?.replace("Subtitle: ","")?.replace("SubDescription: ","")?.replace(`"`,"") ??
                            "Lorem ipsum dolor sit amet consectetur."}
                        </Box>

                        {/* Controls */}
                        <Box
                          display={"flex"}
                          marginTop={isMobileview ? "0px" : "22px"}
                          alignItems={"center"}
                        >
                          {/* Play/Pause Button */}
                          <img
                            src={
                              currentPlaying === index ? PauseIcon : PlayIcon
                            }
                            alt="Play/Pause"
                            style={{
                              width: isMobileview ? "40px" : "50px",
                              height: isMobileview ? "40px" : "50px",
                              borderRadius: "50px",
                              cursor: "pointer",
                            }}
                            onClick={() => togglePlayPause(index)}
                          />

                          {/* Audio Element */}
                          <audio
                            ref={(el) => (audioRefs.current[index] = el)}
                            src={el.audio_url}
                            onTimeUpdate={() => updateTime(index)}
                            onLoadedMetadata={() => updateDuration(index)}
                            onEnded={() => setCurrentPlaying(null)}
                          />

                          {/* Progress & Time */}
                          <Box
                            width={"100%"}
                            display={"flex"}
                            justifyContent={"center"}
                            flexDirection={"column"}
                            marginLeft={"12px"}
                            marginTop={"9px"}
                          >
                            <Slider
                              value={progress[index] || 0}
                              style={{ width: "95%" }}
                              aria-label="progress"
                              min={0}
                              onChange={(e, newValue) =>
                                handleSliderChange(index, newValue)
                              }
                              max={100}
                            />
                            <Box
                              display={"flex"}
                              justifyContent={"space-between"}
                              width={"95%"}
                            >
                              {/* Controls - Rewind, Forward, Mute */}
                              <Box
                                display={"flex"}
                                gap={isMobileview ? "5px" : "10px"}
                              >
                                <img
                                  src={BackwardIcon}
                                  alt="Rewind 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, -10)}
                                />
                                <img
                                  src={ForwardIcon}
                                  alt="Forward 10s"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => seekAudio(index, 10)}
                                />
                                <img
                                  src={muted[index] ? MuteIcon : SoundIcon}
                                  alt="Mute/Unmute"
                                  style={{
                                    width: isMobileview ? "20px" : "28px",
                                    height: isMobileview ? "20px" : "28px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleMute(index)}
                                />
                              </Box>

                              {/* Time Display */}
                              <Box color={"#C789E4"}>
                                {formatTime(
                                  audioRefs.current[index]?.currentTime || 0
                                )}{" "}
                                <span>|</span> {durations[index] || "0:00"}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )
                )}
          </Box>
        )}
      </Box>
      <LoginSignup
        isLoginModalOpen={isLoginModalOpen}
        setIsLoginModalOpen={setIsLoginModalOpen}
        isMobileview={isMobileview}
      />
      <Modal
        open={diyMobile}
        onClose={() => {
          setDiyMobile(false);
          setUploadedFile([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobileview ? "80%" : "32%",
            // height:'430px',
            bgcolor: "background.paper",
            p: isMobileview ? 2 : 4,
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            borderRadius: isMobileview ? "10px" : "20px",
          }}
        >
          <Box fontSize={"14px"} marginTop={"20px"}>
            Transform your research into audio with our innovative podcast
            feature.
          </Box>
          <Box
            // border={"1px solid red"}
            marginTop={"20px"}
            height={"140px"}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={"10px"}
            style={
              {
                // cursor: "pointer",
              }
            }
            className="boxborder"
            // component={"input"}
            type="file"
            component="label"
            position={"relative"}
            padding={"10px"}
          >
            {/* <input type="file" /> */}
            {isLoading ? (
              <img src={animation} style={{ width: "60%", opacity: "0.5" }} />
            ) : !uploadFile.length ? (
              <>
                <img src={upload} style={{ width: "28px", height: "24px" }} />
                <Box>Drag and drop to upload</Box>
                {/* {/* <Box>Or</Box> */}
                <VisuallyHiddenInput
                  type="file"
                  accept=".pdf"
                  onChange={(event) => {
                    setUploadedFile(event.target.files);
                    // setIsLoading(true);
                    // setTimeout(() => {
                    //   setIsLoading(false);
                    // uploadFileConterToPodcast(event);
                    // }, 2000);
                    console.log(event.target.files);
                  }}
                  multiple
                />{" "}
              </>
            ) : (
              <Box>
                {" "}
                <img
                  src={previewupload}
                  style={{ width: "91px", height: "120px" }}
                />
                <img
                  src={close}
                  style={{
                    width: "24px",
                    height: "24px",
                    position: "absolute",
                    top: "7%",
                    cursor: "pointer",
                    right: "35%",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadedFile([]);
                  }}
                />
              </Box>
            )}
          </Box>
          {isLoading == true && (
            <Box fontSize={"14px"} marginTop={"20px"} textAlign={"center"}>
              It will take 2-4 minutes. You can check this in your upload
              section.{" "}
            </Box>
          )}
          <Box
            display={"flex"}
            justifyContent={"flex-end"}
            marginTop={"10px"}
            gap="5px"
          >
            {isLoading == true && (
              <Button
                variant="contained"
                onClick={() => {
                  setDiyMobile(false);
                  setCurrentButton("Your Uploads");
                  setUploadedFile([]);
                  fetchYourUploads(userData?.id);
                }}
              >
                Your Uploads
              </Button>
            )}
            <Button
              variant="contained"
              disabled={uploadFile.length == 0 || isLoading}
              onClick={() => {
                uploadFileConterToPodcast();
              }}
            >
              Generate
            </Button>
          </Box>
        </Box>
      </Modal>
      <Sharecontentmodal
        isShareModalOpen={isShareModalOpen}
        setShareModalOpen={setShareModalOpen}
        ModuleName={"Podcast"}
        link={sharingLink}
        isMobileview={isMobileview}
        mp3Link={mp3Link}
        podcastTitle={podcastTitle}
      />
      <Subscribing />
    </>
  );
};

export default Podcast;
